<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import { useAuthStore } from '@/store/auth';
import ProfileCard from "./components/ProfileCard.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import HeaderHome from "./components/HeaderHome.vue";
const body = document.getElementsByTagName("body")[0];

const store = useStore();
const authStore = useAuthStore();
onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});
onBeforeMount(() => {
  store.state.imageLayout = "profile-overview";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = true;
  body.classList.add("profile-overview");
});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = false;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
});
</script>
<template>
  <main>
    <div class="container-fluid">
      <header-home></header-home>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-body">
              <p class="text-uppercase text-sm">Información del usuario</p>
              <div class="row form-disabled">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Nombre</label
                  >
                  <argon-input type="text" v-model="authStore.infoAcces.user" :disabled="true"/>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Correo Electrónico</label
                  >
                  <argon-input type="email" v-model="authStore.infoAcces.email"/>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Apellidos</label
                  >
                  <input class="form-control" type="text" v-model="authStore.infoAcces.apellidos" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Teléfono</label
                  >
                  <argon-input type="text" v-model="authStore.infoAcces.phone"/>
                </div>
              </div>
              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm">Información del contacto</p>
              <div class="row form-disabled">
            
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >Avatar</label
                  >
                  <argon-input type="text" v-model="authStore.infoAcces.avatar"/>
                </div>
                <p class="text-justify text-sm">
                  En caso de requerir una actualización en sus datos personales, solicitamos enviar un correo electrónico a
                  <a
                    href="mailto:soporte@afcoma.com.mx"
                    class="fw-bold"
                  >
                   <strong>soporte@afcoma.com.mx</strong> 
                  </a>
                  indicando los cambios correspondientes.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <profile-card />
        </div>
      </div>
    </div>
  </main>
</template>

<style>
.form-disabled input,
.form-disabled textarea,
.form-disabled select {
  pointer-events: none;
  opacity: 0.7;
}

</style>
